import { useEffect, useId, useRef, useState } from 'react';
import { Modal } from 'rsuite';
import Input from '../input';
import Button from '../button'

function CustomModal({ title, text, confirmButtonText = 'Yes', cancelButtonText = 'No', onConfirm, onClose, open, confirmText, confirmColor="red", cancelColor="blue", loading, confirmTestId, cancelTestId }) {

    const [confirmCheck, setConfirmCheck] = useState('');
    const confirmationInputRef = useRef(null);
    const confirmationInputId = useId();

    function confirmCheckValid() {
        let disabled = false;
        if (!confirmText) {
            return disabled;
        }
        disabled = confirmCheck.toLocaleLowerCase() !== confirmText.toLocaleLowerCase();
        return disabled;
    }

    function handleConfirmationKeyDown(event) {
        if (event.key !== 'Enter' || event.nativeEvent.isComposing || event.repeat) return;
        event.preventDefault();
        event.stopPropagation();
        if (!open || loading || confirmCheckValid()) return;
        onConfirm?.(event);
    }

    useEffect(() => {
        setConfirmCheck('');
    }, [open]);

    return (
        <Modal backdrop="static" keyboard={false} open={open} onClose={onClose} onEntered={() => confirmationInputRef.current?.focus()}>
            <Modal.Header className='modal-header'>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '16px' }}>
                    {text}
                    {confirmText &&
                        <div style={{marginTop: 16}}>
                            <label htmlFor={confirmationInputId}>Type <span style={{ color: 'var(--error)', fontWeight: 'bolder' }} >{confirmText}</span> in the box below to confirm (not case-sensitive).</label>
                        </div>
                    }
                </div>
                {confirmText &&
                    <div style={{ width: '100%' }}>
                        <Input ref={confirmationInputRef} id={confirmationInputId} style={{ width: '100%' }} value={confirmCheck} onChange={setConfirmCheck} onKeyDown={handleConfirmationKeyDown} autoFocus autoComplete="off" />
                    </div>
                }
            </Modal.Body>
            <Modal.Footer className='modal-footer'>
                <Button className='beststart-button' text={confirmButtonText} color={confirmColor} onClick={onConfirm} disabled={loading || confirmCheckValid()} loading={loading} data-testid={confirmTestId} />
                <Button className='beststart-button' text={cancelButtonText} color={cancelColor} onClick={onClose} loading={loading} data-testid={cancelTestId} />
            </Modal.Footer>
        </Modal>
    );
}

export default CustomModal;
